



















import { Features } from "@/types/settings";
import hitRateStatus from "@/mixins/hit-rate-status";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class HitRate extends Mixins(hitRateStatus) {
  @Getter("stats/allTimeHitRate") allTimeHitRate!: number;
  @Getter("settings/activeCacheFeatures") features!: Features;
  @Getter("processedStats/statLastHour") statLastHour!: (chartID: string, statName: string) => number | null | false;

  @Prop({ required: false, default: "Hit Rate" })
  title!: string;

  get hitRate() {
    if (this.features["collect-granularity"] !== 0) {
      return this.statLastHour("hitRate", "hit_rate");
    }
    return this.allTimeHitRate;
  }

  get hitRateWithUnit() {
    const hr = this.hitRate;
    if ((hr === 0 || hr) && typeof hr === "number") {
      return `${(hr * 100).toFixed()}%`;
    }
    return hr;
  }

  get label() {
    if (this.features["collect-granularity"] !== 0) {
      return "hit rate last hour";
    }
    return "all time hit rate";
  }

  get status() {
    if (this.hitRate === 0 || this.hitRate) {
      return this.hitRateStatus(this.hitRate);
    }
    return { message: "", type: "" };
  }
}
